import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { PresetColors } from "../../../../common/constants";
import { CommissionsBatchStep } from "../enums";

interface Props {
  step?: CommissionsBatchStep;
  closable?: boolean;
  style?: React.CSSProperties;
  onClose?: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  label?: React.ReactNode;
}

export const CommissionsBatchStepTag = ({ step, closable, style, onClose, label }: Props) => {
  const { t } = useTranslation();

  let color;

  switch (step) {
    case CommissionsBatchStep.IMPORT:
      color = PresetColors.VOLCANO;
      break;
    case CommissionsBatchStep.CALCULATION:
      color = PresetColors.BLUE;
      break;
    case CommissionsBatchStep.RECAPITULATION:
      color = PresetColors.GOLD;
      break;
    case CommissionsBatchStep.REVIEW:
      color = PresetColors.PURPLE;
      break;
    case CommissionsBatchStep.FINISH:
      color = PresetColors.GREEN;
      break;
  }

  return step || label ? (
    <Tag color={color} closable={closable} onClose={onClose} style={{ textAlign: "center", minWidth: 94, ...style }}>
      {step ? t("commissions.batch.enums.batchStep." + step) : label}
    </Tag>
  ) : null;
};
